import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import renzyLogo from './../assets/images/svg/renzy-logo.svg';
import homeIcon from './../assets/images/svg/home-icon.svg';
import homeActive from './../assets/images/svg/home-active.svg';
import hamburger from './../assets/images/svg/hamburger.svg';
import closeIcon from './../assets/images/svg/close-icon.svg';
import userIcon from './../assets/images/svg/user.svg';
import { handleMouseMove } from '../constants/ButtonHover';
const Header = () => {
    const [isMenuOpen, setMenuOpen] = useState(false);
    const location = useLocation();
    const isHome = location.pathname === '/';
    // Close menu on window resize if desktop
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 992) {
                setMenuOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    useEffect(() => {
        if (isMenuOpen) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isMenuOpen]);
    return (_jsxs("header", Object.assign({ className: "header" }, { children: [_jsx("div", Object.assign({ className: "logo" }, { children: _jsx(Link, Object.assign({ to: "/" }, { children: _jsx("img", { src: renzyLogo, alt: "Renzy-Logo", width: "100%", height: "100%" }) })) })), _jsx("div", { className: `mobile-overlay ${isMenuOpen ? 'open' : ''}`, onClick: () => setMenuOpen(false), role: "button", tabIndex: 0, onKeyDown: (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        setMenuOpen(false);
                    }
                }, "aria-label": "Close menu" }), _jsxs("div", Object.assign({ className: `nav ${isMenuOpen ? 'open' : ''}` }, { children: [_jsx(NavLink, Object.assign({ to: "/", onClick: () => setMenuOpen(false) }, { children: isMenuOpen ? (_jsx(_Fragment, { children: "Home" })) : (_jsx("img", { src: isHome ? homeActive : homeIcon, alt: "homeIcon", className: "home-icon", width: "24", height: "24" })) })), _jsx(NavLink, Object.assign({ to: "/rent", onClick: () => setMenuOpen(false) }, { children: "Rent" })), _jsx(NavLink, Object.assign({ to: "/rewards", onClick: () => setMenuOpen(false) }, { children: "Rewards" })), _jsx(NavLink, Object.assign({ to: "/blog", onClick: () => setMenuOpen(false) }, { children: "Blog" })), _jsx(NavLink, Object.assign({ to: "/faq", onClick: () => setMenuOpen(false) }, { children: "FAQ" })), _jsx("button", Object.assign({ onMouseMove: handleMouseMove, onClick: () => window.open(process.env.REACT_RENZY_APP, '_blank', 'noopener,noreferrer'), className: "external-link button" }, { children: _jsxs(NavLink, Object.assign({ className: "", to: "#", onClick: (e) => {
                                e.preventDefault();
                                setMenuOpen(false);
                            } }, { children: [_jsx("img", { src: userIcon, alt: "user-icon", className: "user-icon", width: "13", height: "16" }), " Sign In / Sign Up"] })) }))] })), _jsx("button", Object.assign({ className: "hamburger", onClick: () => setMenuOpen(!isMenuOpen) }, { children: _jsx("img", { src: isMenuOpen ? closeIcon : hamburger, alt: "Hamburger", width: "24", height: "24" }) }))] })));
};
export default Header;
